import { render, staticRenderFns } from "./modalImage.vue?vue&type=template&id=6efa5855&scoped=true&"
import script from "./modalImage.vue?vue&type=script&lang=js&"
export * from "./modalImage.vue?vue&type=script&lang=js&"
import style0 from "./modalImage.vue?vue&type=style&index=0&id=6efa5855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa5855",
  null
  
)

export default component.exports